import React, { useEffect, useState } from 'react';

import { useNavigate } from "react-router-dom";
import { NotifyModal } from '../../components/NotifyModal/NotifyModal';

import MyVerticallyCenteredModal from './components/MyVerticallyCenteredModal';
import MyMapComponent from './components/MyMapComponent';
import Reload from '../../components/reload/reload';
import Page from '../../components/Page/Page';

import { Alert } from 'react-bootstrap';
import getToken from '../../hooks/getToken';
import axios from 'axios';

const AcessoRestrito = () => {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user'));
  if (user?.permissionSGU?.restricted?.read !== true || user?.permissionSGU?.restrictedP?.read !== true) {
    navigate("/");
  }

  const units = JSON.parse(localStorage.getItem('units')) || [JSON.parse(localStorage.getItem('cooperative'))] || [];

  const [empresa,] = useState(JSON.parse(localStorage.getItem('cooperative')));

  const [center, setCenter] = useState(null);
  const [fixedCenter, setFixedCenter] = useState(null);

  const [markers, setMarkers] = useState([]);

  const [modalShow, setModalShow] = useState(false);
  const [modalShowConfig, setModalShowConfig] = useState(false);

  const [loading, setLoading] = useState(true);

  const [validNameEmpresa, setValidNameEmpresa] = useState(false);
  const [type, setType] = useState({ color: "", status: "" });


  useEffect(() => {
    const checkValueInArray = (array, value) => {
      if (!value) return false;
      return array.some(item => value?.toUpperCase().includes(item.toUpperCase()));
    };

    const myArray = process.env.REACT_APP_CLIENT_P ? process.env.REACT_APP_CLIENT_P.split(",") : [];
    const result = checkValueInArray(myArray, empresa?.name);

    setValidNameEmpresa(result);
  }, [empresa]);

  const handleChangeChartModal = async (selectedOptions) => {
    setModalShowConfig(false);

    if (!selectedOptions) {
      return;
    }

    try {
      await axios.post('/api/company/v1/chartpp/update', { _list: selectedOptions, token: getToken() });

      const updatedEmpresa = { ...empresa };
      const updatedUnits = (JSON.parse(localStorage.getItem('units')) || [JSON.parse(localStorage.getItem('cooperative'))] || []).map((unit) => {
        const selectedCompany = selectedOptions.find(option => option._id === unit._id);
        const newPP = selectedCompany ? selectedCompany.pp : unit.pp;

        if (updatedEmpresa._id === unit._id) {
          updatedEmpresa.pp = newPP;
        }

        return { ...unit, pp: newPP };
      });

      const selectedCompany = selectedOptions.find(option => option._id === empresa._id);
      const pp = selectedCompany ? selectedCompany.pp : 0;

      setCenter((prevCenter) => ({
        ...prevCenter,
        pp: pp,
      }));

      localStorage.setItem('cooperative', JSON.stringify(updatedEmpresa));
      if (localStorage.getItem('units')) {
        localStorage.setItem('units', JSON.stringify(updatedUnits));
      }

      getMakers();
      setType({ color: "#198754", status: "Atualizado com sucesso!" });
      setModalShow(true);

    } catch (error) {
      setType({ color: "#FF0000", status: "Erro ao atualizar!" });
      setModalShow(true);
    }
  };

  const getMakers = async () => {
    const units = JSON.parse(localStorage.getItem('units')) || [JSON.parse(localStorage.getItem('cooperative'))] || [];
    let mks = units.filter(i => i.location).map(item => {
      return {
        lat: parseFloat(item.location.lat),
        lng: parseFloat(item.location.lng),
        pp: item.pp,
        i: true,
        _id: item._id
      }
    })

    setMarkers(mks);
    setLoading(false)
  }

  useEffect(() => {
    if (empresa.location && empresa.location && empresa.location.lng) {
      setCenter({
        lat: parseFloat(empresa.location.lat),
        lng: parseFloat(empresa.location.lng),
        pp: typeof empresa.pp === 'number' ? empresa.pp : 0
      });

      setFixedCenter({
        lat: parseFloat(empresa.location.lat),
        lng: parseFloat(empresa.location.lng),
        pp: typeof empresa.pp === 'number' ? empresa.pp : 0
      });
    }
    getMakers()
  }, [empresa])

  const handleModalShowConfig = () => {
    setModalShowConfig(modalShowConfig === true ? false : true);
  }

  return (
    <Page title={"Restrito"}>

      {loading && <Reload />}

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Alert
        variant="dark"
        dismissible
        className="text-center mb-3 border-0 shadow-sm"
        style={{
          fontSize: "0.9rem",
          background: "rgba(15, 23, 42, 0.9)",
          color: "#e5e7eb"
        }}
      >
        ⚠️ Este sistema possibilita a gestão de um ou mais equipamentos conectados, garantindo controle total para prevenir erros operacionais e uso indevido.
      </Alert>

      <MyVerticallyCenteredModal
        validNameEmpresa={validNameEmpresa}
        permissions={user?.permissionSGU}
        units={units}
        show={modalShowConfig}
        handleChangeChartModal={handleChangeChartModal}
        onHide={() => { setModalShowConfig(false) }}
      />

      {empresa.location && empresa.location.lat && empresa.location.lng ?
        <MyMapComponent
          validNameEmpresa={validNameEmpresa}
          permissions={user?.permissionSGU}
          markers={markers}
          units={units}
          center={center}
          fixedCenter={fixedCenter}
          setCenter={setCenter}
          handleModalShowConfig={handleModalShowConfig}
        /> :
        <Alert
          variant="dark"
          dismissible
          className="text-center mb-3 border-0 shadow-sm"
          style={{
            fontSize: "0.9rem",
            background: "rgba(127, 29, 29, 0.9)",
            color: "#fef2f2"
          }}
        >
          ⚠️ Localização da empresa não encontrada! Entre em contato com o administrador.
        </Alert>
      }
    </Page>
  )
}
export default AcessoRestrito;
